import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import * as QRCode from 'qrcode';

@Component({
  selector: 'app-purchase-order-pdf',
  standalone: true,
  imports: [SharedModule,CommonModule],
  templateUrl: './purchase-order-pdf.component.html',
  styleUrl: './purchase-order-pdf.component.scss'
})
export class PurchaseOrderPdfComponent {
  @Input() orderData: any; // Accept data as input
  @Input() factories:any[];
  @Input() salesMen:any[];
  @Input() customerAddresses:any[];

  qrCodeData = 'https://www.google.com/';
  baseUrl = window.location.origin; // Base URL
  qrCodeImage: string = '';
  selectedFactory:any;
  selectedSalesMan:any;
  
  constructor(private el: ElementRef) {}

  

  ngOnChanges(){
    // // debugger;
    //console.log(this.orderData);
    this.selectedFactory=this.factories?.find(fact=>fact.id==this.orderData.factoryId);
    this.selectedSalesMan=this.salesMen?.find(sales=>sales.id==this.orderData.salesManId);
    this.qrCodeData=this.baseUrl+'/transactions/purchase-order/view/'+this.orderData?.id;
    this.generateQRCode();
    this.orderData?.purchaseOrderLines?.forEach((line,index)=>{
      const addressName=this.customerAddresses.find(address=>address.id==line.customerAddressId)?.name;
      line.addressName = addressName; // Add `addressName` to the existing object
    })
  }

  // Method to get the element (the part you want to use in html2pdf)
  getReportElement(): HTMLElement {
    // debugger
    return this.el.nativeElement.querySelector('#report-content'); // Assuming .report-content is the class for your report content
  }

  generateQRCode() {
    QRCode.toDataURL(this.qrCodeData, { width: 200 }, (err, url) => {
      if (err) {
        console.error('Error generating QR code:', err);
        return;
      }
      this.qrCodeImage = url;
    });
  }
}
